import {ITableProps} from "@ui/tableCustom/types/table";
import {useFullScreenMode} from "@ui/tableCustom/hooks/useFullScreenMode";
import ModalFullScreen from "@ui/modal/modalFullScreen/ModalFullScreen";
import BaseTableFeatures from "@ui/tableCustom/tableFeatures/BaseTableFeatures";

function TableFeaturesWithModalFullScreen<T>({
                                                  isLoading,
                                                  isError,
                                                  hasExportDataFromAllPage,
                                                  mapperRowCb,
                                                  data,
                                                  allData,
                                                  fullColumns,
                                                  headColumns,
                                                  params,
                                                  headSideBar,
                                                  secondarySidebar,
                                                  hasExport = true,
                                                  exportParams,
                                                  mapperColumnCb,
                                                  baseExportStyles,
                                                  generateExportExcelRowStylesCb,
                                                  generateExportExcelHeadColumnStylesCb,
                                                  headerExportContents,
                                                  initialStickyHeader,
                                                  changeExportSidebarSettings,
                                                  hasPdfExport = true,
                                                  sx,
                                                  lastTableRow,
                                                  menuSettingsTable,
                                                  hasModalFullScreen,
                                                  totalPage,
                                                  paginationProps,
                                              }: ITableProps<T>) {

    const {
        fullScreenMode,
        setFullScreenMode,
        innerRef,
        maxHeightScreen,
    } = useFullScreenMode()

    return (
        <ModalFullScreen
            fullScreenMode={fullScreenMode}
            setFullScreenMode={setFullScreenMode}
            showActionPanel={false}
        >
            <BaseTableFeatures
                <T>
                isLoading={isLoading}
                isError={isError}
                hasExportDataFromAllPage={hasExportDataFromAllPage}
                mapperRowCb={mapperRowCb}
                data={data}
                allData={allData}
                fullColumns={fullColumns}
                headColumns={headColumns}
                params={params}
                headSideBar={headSideBar}
                secondarySidebar={secondarySidebar}
                hasExport={hasExport}
                exportParams={exportParams}
                mapperColumnCb={mapperColumnCb}
                baseExportStyles={baseExportStyles}
                generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
                generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
                headerExportContents={headerExportContents}
                initialStickyHeader={initialStickyHeader}
                changeExportSidebarSettings={changeExportSidebarSettings}
                paginationProps={paginationProps}
                hasPdfExport={hasPdfExport}
                sx={sx}
                lastTableRow={lastTableRow}
                menuSettingsTable={menuSettingsTable}
                innerRef={innerRef as any}
                maxHeightScreen={maxHeightScreen}
                hasModalFullScreen={hasModalFullScreen}
                fullScreenMode={fullScreenMode}
                setFullScreenMode={setFullScreenMode}
                totalPage={totalPage}
            />
        </ModalFullScreen>

    )
}


export default TableFeaturesWithModalFullScreen